"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByLimit = getByLimit;
async function getByLimit(client, url, query) {
    const result = [];
    let remainingLimit = query?.limit || 0;
    let page = 1;
    let hasMoreData = true;
    while (hasMoreData && remainingLimit > 0) {
        try {
            const response = await client.get(url, {
                params: {
                    ...query,
                    page,
                    limit: Math.min(remainingLimit, 100),
                },
            });
            const { data } = response;
            if (Array.isArray(data) && data.length > 0) {
                result.push(...data);
                remainingLimit -= data.length;
                page++;
            }
            else {
                hasMoreData = false;
            }
        }
        catch (error) {
            throw new Error(`Error retrieving data on page ${page} caused by ${error.message}`);
        }
    }
    return result;
}
